// import { constantRouterMap } from '@/router'

const app = {
	state: {
		// 左侧导航
		routes: [],

		// 左侧导航状态
		sidebar: {
			opened: window.sessionStorage.getItem('sidebarStatus') == 1,
			withoutAnimation: false
		},

		// 隐藏的面包屑数组
		hidebreads: [],

		// 设备 { desktop: 桌面, mobile: 手机 }
		device: 'desktop',

		// 环境 { admin: 线上, develop: 测试, local: 本地 }
		environment: 'admin',

		// main区域的根节点el
		mainroot: undefined,

		// 可视区域高度（减去顶部栏部分）
		mainheight: 0,

		// keep-alive的views数组
		cacheviews: []
	},
	mutations: {
		TOGGLE_DEVICE: (state, device) => {
			state.device = device
		},
		SET_ROUTERS: (state, routers) => {
            state.routes = routers
        },
        UPDATE_ROUTERS: (state, { key, meta }) => {
            if (!key) {
                return;
            }
            const names = key.split('.');
            const route = state.routes.find(route => route.name == names[0]);
            if (names.length === 1) {
                Object.assign(route.meta, meta);
            } else {
                const childRoute = route.children.find(item => item.name == names[1]);
                Object.assign(childRoute.meta, meta);
                let tips = 0;
                const children = route.children.map(item => {
                    let newItem = item;
                    if (item.name == names[1]) { 
                        newItem = { ...item, meta: Object.assign({}, item.meta, meta) };
                    }
                    if (newItem.tipsIcon) {
                        tips++;
                    }
                    return newItem;
                });
                Object.assign(route, { children, meta: { ...route.meta, tipsIcon: tips > 0 ? route.meta.tipsIcon : '' } });
            }
        },
		SET_HIDEBREADS: (state, route) => {
			state.hidebreads.push(route)
		},
		SET_ENVIRONMENT: (state, evn) => {
			state.environment = evn
		},
		SET_MAINROOT: (state, root) => {
			state.mainroot = root
		},
		SET_MAINHEIGHT: (state, root) => {
			state.mainheight = root
		},
		SET_CACHEVIEWS: (state, view) => {
			state.cacheviews.push(view)
		}
	},
	actions: {
		// 设备判断
		toggleDevice({ commit }, device) {
			commit('TOGGLE_DEVICE', device)
		},

		// 设置nav
		computedNav({ commit }, routers) {
			commit('SET_ROUTERS', routers)
		},

		// 设置隐藏面包屑（children.length == 1）
		setHideBreads({ commit }, route) {
			if (this.state.app.hidebreads.indexOf(route) == -1) {
				commit('SET_HIDEBREADS', route)
			}
		},

		// 设置环境
		setEnvironment({ commit }, env) {
			commit('SET_ENVIRONMENT', env)
		},

		// 设置main-wrap根节点el
		setMainRoot({ commit }, root) {
			commit('SET_MAINROOT', root)
		},

		// 设置可视区域高度
		setMainHeight({ commit }, height) {
			commit('SET_MAINHEIGHT', height)
		},

		// 添加缓存的views
		addCacheViews({ commit }, view) {
			if (this.state.app.cacheviews.indexOf(view) == -1) {
				commit('SET_CACHEVIEWS', view)
			}
		}
	}
}

export default app
